<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title">
      {{ 'GROUPS.DIALOG.TABS.USERS.LINKED.ADD' | translate }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="field-dialog__content">
    <form
      #form
      fxLayout="column"
      autocomplete="off"
      class="field-dialog__content__scroll tab-users p-24"
      fusePerfectScrollbar
    >
      <div class="field-outline-form">
        <div class="tab-users__search-bar">
          <mat-form-field #outlineFieldRef appearance="outline">
            <mat-label>
              {{ 'GROUPS.DIALOG.TABS.USERS.LINK.SEARCH' | translate }}
            </mat-label>

            <mat-icon matPrefix color="primary">search</mat-icon>
            <input
              matInput
              [formControl]="searchUsersInputValue"
              (keydown)="$event.stopImmediatePropagation()"
              (focus)="outlineFieldRef.updateOutlineGap()"
              [disabled]="isLoading"
            />

            <mat-hint>
              {{ 'GROUPS.DIALOG.TABS.USERS.SEARCH_SUGGESTION' | translate }}
            </mat-hint>
          </mat-form-field>
        </div>
      </div>

      <ng-container *ngIf="page?.items">
        <div fxLayout="row" fxLayoutAlign="space-between start">
          <p class="field-dialog__content__scroll__title">
            {{ 'GROUPS.DIALOG.TABS.USERS.LINK.TITLE' | translate }} ({{ page?.totalCount || 0 }})
          </p>

          <mat-checkbox
            class="mr-17"
            data-cy="select-all-checkbox"
            [checked]="isAllSelected || linkAllUsers"
            [disabled]="isLoading || !page?.items.length || isAllLinkedUsers()"
            (change)="toggleAllSelected($event.checked)"
          >
          </mat-checkbox>
        </div>

        <app-select-info-banner
          *ngIf="isAllSelected || linkAllUsers"
          [totalItems]="page?.totalCount"
          [selectAllItems]="selectAllUsers.bind(this)"
          [linkAllItems]="linkAllUsers"
        ></app-select-info-banner>

        <div class="tab-users__body">
          <p *ngIf="!page?.items" class="tab-users__body__not-found-title">
            {{ 'GROUPS.DIALOG.TABS.USERS.LINK.NOT_FOUND' | translate }}
          </p>

          <ng-container *ngIf="page?.items">
            <div
              class="card tab-users__body__card"
              *ngFor="let user of page?.items"
              fxLayout="row"
              fxLayout="space-between center"
              fxLayoutGap="16px"
            >
              <img
                class="tab-users__body__card__avatar"
                [alt]="user.name"
                [src]="user.avatarUrl || 'https://ui-avatars.com/api/?name=' + user.name"
              />

              <div fxLayout="column" fxLayoutAlign="center start" fxFlex>
                <p class="tab-users__body__card__name">
                  {{ user.name }}
                </p>
                <p class="tab-users__body__card__email">
                  {{ user.email }}
                </p>
              </div>

              <div fxLayout="column" fxLayoutAlign="center start">
                <p *ngIf="user.groupsConnection?.items?.length" class="tab-users__body__card__linked">
                  {{ 'GROUPS.DIALOG.TABS.USERS.LINK.ALREADY_LINKED' | translate }}
                </p>

                <mat-checkbox
                  *ngIf="!user.groupsConnection?.items?.length"
                  (change)="toggleUserLinkedToGroup($event.checked, user)"
                  [checked]="usersToAdd.has(user.id) || linkAllUsers"
                  [disabled]="isLoading"
                ></mat-checkbox>
              </div>
            </div>

            <div class="tab-users__paginator-wrapper">
              <fc-paginator
                class="tab-users__paginator"
                #paginator
                [pageSize]="pageSize"
                [totalCount]="page?.totalCount"
                [currentPageLength]="page?.items.length"
                [isLoading]="isPageChanging"
                (page)="onPageChange($event)"
              ></fc-paginator>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="!page?.items">
        <div fxLayout="column" fxLayoutAlign="center center">
          <mat-spinner color="primary" diameter="64" class="mb-24"></mat-spinner>
          {{ 'GROUPS.DIALOG.TABS.USERS.LOADING' | translate }}
        </div>
      </ng-container>
    </form>
  </div>

  <div class="field-dialog__footer" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout="row">
    <button class="field-background" mat-raised-button (click)="linkUsers()">
      {{ 'GROUPS.DIALOG.LINK' | translate }}
    </button>

    <button class="field-background--stroked" mat-stroked-button mat-dialog-close>
      {{ 'GROUPS.DIALOG.BACK' | translate }}
    </button>
  </div>
</div>
